import { Component, inject,signal } from '@angular/core';
import { CitiesListComponent } from '../../../../components/admin-dashboard-component/system-settings/cities/cities-list-component/cities-list-component';
import { AddIcon } from '../../../../shared/ui/icons/add-icon/add-icon';
import { ActivatedRoute, RouterLink } from '@angular/router';

@Component({
  selector: 'app-list-cities',
  imports: [CitiesListComponent, AddIcon , RouterLink],
  templateUrl: './list-cities.html',
  styleUrl: './list-cities.scss',
})
export class ListCities {
  private activatedRoute = inject(ActivatedRoute);
  cityId = signal('');
  ngOnInit() {
    this.cityId.set(this.activatedRoute.snapshot.paramMap.get('id') as string);
  }
}
